module.exports = __webpack_public_path__ + "img/canxuly.b546c818.png";